import { render, staticRenderFns } from "./xptj.vue?vue&type=template&id=204c1e0d&"
import script from "./xptj.vue?vue&type=script&lang=js&"
export * from "./xptj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports